import { useTranslation } from 'react-i18next';
import { profile } from '../../content/profile.js';

export function WhatHappensNext() {
  const { t } = useTranslation(['common', 'next']);

  return (
    <aside className="next">
      <div className="next__title">{t('next:title')}</div>

      <div className="next__steps">
        {profile.steps.map((step, index) => (
          <div key={step} className="next__step">
            <span className="next__number" dir="ltr">
              {String(index + 1).padStart(2, '0')}
            </span>
            <div>
              <div className="next__step-title">{t(`next:steps.${step}.title`)}</div>
              <div className="next__step-text">{t(`next:steps.${step}.body`)}</div>
            </div>
          </div>
        ))}
      </div>

      <div className="next__signature">
        <img
          className="next__avatar"
          src={profile.avatar}
          alt={t('common:portraitAlt')}
          width={46}
          height={46}
          loading="lazy"
        />
        <div>
          <div className="next__name">{profile.name}</div>
          <div className="next__meta">{t('next:replyNote')}</div>
        </div>
      </div>
    </aside>
  );
}
